import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="category-slider"',
}

const initSection = (section) => {
  const json = JSON.parse(section.querySelector('[type="application/json"]').innerHTML)
  new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: json.mobile + 0.25,
    spaceBetween: 12,
    breakpoints: {
      320: {
        slidesPerView: json.mobile + 0.5,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: json.tablet + 0.5,
      },
      1024: {
        slidesPerView: json.desktop + 0.5,
        spaceBetween: 16,
      },
      1440: {
        slidesPerView: json.large + 0.5,
        spaceBetween: 16,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}

export const setupCategorySlider = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    initSection(section)
  })
}